import React from 'react';
import {Tag, Button} from 'antd';
import {
    UserOutlined, MailOutlined, PhoneOutlined, ApartmentOutlined,
    ProjectOutlined, CalendarOutlined, TeamOutlined,
    FilePdfOutlined, DownloadOutlined
} from "@ant-design/icons";

const FieldRow = ({icon, label, value}) => (
    <div className="flex items-start gap-3 rounded-lg bg-gray-50 px-4 py-3">
        <div className="text-red-600 text-lg mt-0.5">{icon}</div>
        <div className="min-w-0">
            <div className="text-xs uppercase tracking-wider text-slate-500">{label}</div>
            <div className="text-slate-900 font-medium break-words">
                {value || <span className="text-slate-400">—</span>}
            </div>
        </div>
    </div>
);

const UserDetailView = ({data, handleViewDocument}) => {
    if (!data) return null;

    return (
        <div className="rounded-2xl border border-slate-200 bg-white shadow-sm">
            <div className="p-6 border-b border-slate-100">
                <div className="flex items-center gap-3">
                    <div className="h-12 w-12 rounded-full bg-gray-100 text-red-600 flex items-center justify-center">
                        <UserOutlined className="text-xl"/>
                    </div>
                    <div>
                        <h1 className="text-2xl font-semibold text-slate-900 mb-0">
                            {data.full_name || "User"}
                        </h1>
                    </div>
                </div>
            </div>

            <div className="p-6">
                <div className="grid md:grid-cols-2 gap-4">
                    <FieldRow icon={<MailOutlined/>} label="Email" value={data.email}/>
                    <FieldRow icon={<PhoneOutlined/>} label="Mobile Number" value={data.mobile_number}/>
                    <FieldRow icon={<ApartmentOutlined/>} label="Company Name" value={data.company_name}/>

                    <FieldRow
                        icon={<ProjectOutlined/>}
                        label="Project"
                        value={
                            <div className="flex flex-wrap gap-1">
                                {Array.isArray(data.project) && data.project.length > 0 ? (
                                    data.project.map((name) => <Tag color="gray" key={name}>{name}</Tag>)
                                ) : <span className="text-slate-300">No Projects Assigned</span>}
                            </div>
                        }
                    />

                    <FieldRow icon={<CalendarOutlined/>} label="Work Start Date" value={data.work_start_date}/>
                    <FieldRow icon={<CalendarOutlined/>} label="Work End Date" value={data.work_end_date}/>

                    <FieldRow
                        icon={<TeamOutlined/>}
                        label="Managers"
                        value={
                            <div className="flex flex-wrap gap-1">
                                {Array.isArray(data.manager_ids) && data.manager_ids.length > 0 ? (
                                    data.manager_ids.map((email) => <Tag color="gray" key={email}>{email}</Tag>)
                                ) : <span className="text-slate-300">No Managers Assigned</span>}
                            </div>
                        }
                    />

                    <FieldRow
                        icon={<TeamOutlined/>}
                        label="External Managers"
                        value={
                            <div className="flex flex-wrap gap-1">
                                {Array.isArray(data.external_manager_ids) && data.external_manager_ids.length > 0 ? (
                                    data.external_manager_ids.map((email) => <Tag color="gray" key={email}>{email}</Tag>)
                                ) : <span className="text-slate-300">No Managers Assigned</span>}
                            </div>
                        }
                    />

                    <FieldRow
                        icon={<FilePdfOutlined/>}
                        label="NDA Document"
                        value={
                            data.NDA_doc ? (
                                <Button
                                    type="default"
                                    size="small"
                                    className="mt-2"
                                    icon={<DownloadOutlined/>}
                                    onClick={() => handleViewDocument(data.NDA_doc)}
                                >
                                    {data.NDA_doc.split('/').pop()}
                                </Button>
                            ) : <span className="text-slate-300">Not Uploaded</span>
                        }
                    />

                    <FieldRow
                        icon={<FilePdfOutlined/>}
                        label="Other Document"
                        value={
                            data.other_doc ? (
                                <Button
                                    type="default"
                                    size="small"
                                    className="mt-2"
                                    icon={<DownloadOutlined/>}
                                    onClick={() => handleViewDocument(data.other_doc)}
                                >
                                    {data.other_doc.split('/').pop()}
                                </Button>
                            ) : <span className="text-slate-300">Not Uploaded</span>
                        }
                    />
                </div>
            </div>
        </div>
    );
};

export default UserDetailView;